export function progressViewChange(successCount: number, failCount: number, base: number) {
    const progressModal = document.getElementById('progress-modal') as HTMLElement;
    const progressPercentage = progressModal.querySelector('.modal-body p') as HTMLElement;
    const progressBar = progressModal.querySelector('progress') as HTMLElement;
    const percentage = Math.floor((successCount + failCount) / base * 100);
    progressPercentage.textContent = ` ${percentage}% [${(successCount + failCount)} / ${base} (成功 : ${successCount}, 失敗 : ${failCount})]`
    progressBar.setAttribute('value', `${percentage}`)

    if (percentage >= 100) {
        const progressResult = progressModal.querySelector('.result') as HTMLElement;
        const resultView = (failCount > 0) ? ['fail', '失敗した処理があります。'] : ['success', '成功しました。']
        progressResult.classList.add(resultView[0])
        progressResult.textContent = resultView[1]
    }
}

export function progressModalInitView() {
    const progressModal = document.getElementById('progress-modal') as HTMLElement;
    const progressPercentage = progressModal.querySelector('.modal-body p') as HTMLElement;
    const progressBar = progressModal.querySelector('progress') as HTMLElement;
    progressPercentage.textContent = ''
    progressBar.setAttribute('value', '')

    const progressResult = progressModal.querySelector('.result') as HTMLElement;
    progressResult.classList.remove('success', 'fail')
    progressResult.textContent = ''
    progressModal.style.display = 'block';
    // successCount, failCountを0にするため
    return [0, 0]
}

export function progressModalHandler() {
    const progressModal = document.getElementById('progress-modal') as HTMLElement;

    const progressBarCloseButton = document.querySelector('.progress-bar-close-button') as HTMLElement;
    progressBarCloseButton.addEventListener('click', () => {
        progressModal.style.display = 'none';
    });
}
